import { extendTheme } from "@chakra-ui/react";
import { brandConfig } from "./brandConfig";

/**
 * Centralized Chakra UI Theme Configuration
 *
 * This theme file integrates brandConfig fonts and ensures consistent typography
 * across the entire application.
 */

const theme = extendTheme({
  // Color mode configuration
  config: {
    // Build-time default from brandConfig; the tenant record's colorMode is
    // applied at runtime by TenantBrandingLoader when the viewer has no
    // preference of their own.
    initialColorMode: brandConfig.colorMode ?? 'dark',
    useSystemColorMode: false,
  },

  // Typography via the --brand-font-* custom properties so a tenant font
  // overlaid at runtime (applyTenantBranding rewrites #tenant-brand-overrides)
  // takes effect without re-extending the theme. The vars are seeded from
  // brandConfig.fonts in index.tsx before React mounts.
  fonts: {
    heading: 'var(--brand-font-heading)',
    body: 'var(--brand-font-body)',
  },

  // Global styles
  styles: {
    global: {
      // Body-level styles
      body: {
        fontFamily: 'var(--brand-font-body)',
      },
      // Heading styles
      "h1, h2, h3, h4, h5, h6": {
        fontFamily: 'var(--brand-font-heading)',
      },
    },
  },

  // Component-specific overrides
  components: {
    Heading: {
      baseStyle: {
        fontFamily: 'var(--brand-font-heading)',
      },
    },
    Text: {
      baseStyle: {
        fontFamily: 'var(--brand-font-body)',
      },
    },
    Button: {
      baseStyle: {
        fontFamily: 'var(--brand-font-body)',
      },
    },
  },
});

export default theme;
